/* HC graphics kit (assets/hc-fx.css): finds dark and light areas and dresses them, draws the hero underline, lights up process steps,
   adds the footer wordmark and starts the illustrations in snippets/hc-fx-art.liquid when they scroll into view.
   Purely decorative layers (aria-hidden); pages with their own art direction (video pack, hooks, checklist) are left alone. */
(function () {
  var main = document.querySelector('main');
  if (!main) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  var OWN = '[class*="hvp"], [class*="hkl-"], [class*="hcl-"], [class*="hca"], [class*="hch-"], [data-hcr]';
  var ownPage = !!main.querySelector('.hvp, .hkl, .hcl, .hca');

  function rgb(c) {
    var v = (c || '').match(/[\d.]+/g);
    if (!v || v.length < 3) return null;
    return { r: +v[0], g: +v[1], b: +v[2], a: v[3] === undefined ? 1 : +v[3] };
  }
  function isDark(c) { var v = rgb(c); return v && v.a > .9 && v.r + v.g + v.b < 75; }
  function isLight(c) { var v = rgb(c); return v && v.a > .9 && v.r + v.g + v.b > 700; }
  function host(el) {
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.classList.add('hc-fx-host');
  }
  function seeded(n) { var x = Math.sin(n * 9301 + 49297) * 233280; return x - Math.floor(x); }

  /* 1. Dark areas: grid, lit pixels, glow and guide lights (sized to the area). */
  function dressDark(el, idx, soft) {
    if (el.querySelector(':scope > .hc-fx-bg')) return;
    el.classList.add('hc-fx-dark');
    var r = el.getBoundingClientRect();
    var cell = mobile ? 44 : 60;
    host(el);
    var bg = document.createElement('div');
    bg.className = 'hc-fx-bg' + (soft ? ' hc-fx-bg--soft' : '');
    bg.setAttribute('aria-hidden', 'true');
    bg.style.setProperty('--hc-fx-cell', cell + 'px');
    var html = '<span class="hc-fx-bg__grid"></span><span class="hc-fx-bg__glow"></span>';
    if (r.height > 700) html += '<span class="hc-fx-bg__glow hc-fx-bg__glow--low"></span>';
    if (!reduce) {
      var cols = Math.max(1, Math.floor(r.width / cell)), rows = Math.max(1, Math.floor(Math.min(r.height, 1400) / cell));
      var count = Math.min(mobile ? 6 : 11, Math.round(cols * rows / 9));
      var offset = (r.width - cols * cell) / 2;
      for (var i = 0; i < count; i++) {
        // Keep lit pixels in the outer columns so they never sit behind copy.
        var band = Math.max(1, Math.floor(cols * (mobile ? .18 : .22)));
        var pick = Math.floor(seeded(idx * 31 + i) * band * 2);
        // Phones run copy edge to edge, so their pixels stay in the top band above the heading.
        var cx = pick < band ? pick : cols - band * 2 + pick, cy = Math.floor(seeded(idx * 17 + i * 7) * (mobile ? Math.min(rows, 2) : rows));
        html += '<i class="hc-fx-px" style="--x:' + Math.round(offset + cx * cell) + 'px;--y:' + cy * cell + 'px;--t:' + (5 + seeded(i + idx) * 5).toFixed(1) + 's;--d:-' + (seeded(i * 3 + idx) * 8).toFixed(1) + 's"></i>';
      }
      if (r.width > 900 && window.matchMedia('(min-width: 993px)').matches) html += '<b class="hc-fx-guide" style="--x:calc(50% - min(600px, 50% - 24px));--d:-1s"></b><b class="hc-fx-guide" style="--x:calc(50% + min(600px, 50% - 24px) - 1px);--d:-4.5s"></b>';
    }
    bg.innerHTML = html;
    el.insertBefore(bg, el.firstChild);
  }

  /* 2. Light sections: a fading paper grid behind the heading. */
  function dressLight(el) {
    if (el.querySelector(':scope > .hc-fx-paper')) return;
    host(el);
    var p = document.createElement('div');
    p.className = 'hc-fx-paper';
    p.setAttribute('aria-hidden', 'true');
    el.insertBefore(p, el.firstChild);
  }

  if (!ownPage) {
    var sections = main.querySelectorAll('.shopify-section');
    var idx = 0;
    Array.prototype.forEach.call(sections, function (s) {
      if (s.matches(OWN) || s.querySelector('.hvp, .hkl, .hcl, .hca')) return;
      var sr = s.getBoundingClientRect();
      if (sr.height < 200) return;
      // The element that actually paints the section background (section or a near full-size child).
      var paint = null;
      var cands = [s].concat(Array.prototype.slice.call(s.querySelectorAll(':scope > *, :scope > * > *')));
      for (var i = 0; i < cands.length; i++) {
        var c = cands[i], cr = c.getBoundingClientRect();
        if (cr.height < sr.height * .7 || cr.width < sr.width * .9) continue;
        var bgc = getComputedStyle(c).backgroundColor;
        if (isDark(bgc) || isLight(bgc)) { paint = c; break; }
      }
      if (paint && isDark(getComputedStyle(paint).backgroundColor)) dressDark(paint, idx++);
      else if (paint && s.querySelector('h1, h2')) dressLight(paint);
      // Dark cards inside the section (case study box, process card, offers).
      Array.prototype.forEach.call(s.querySelectorAll('div, section, article'), function (box) {
        if (box === paint || box.closest('.hc-fx-bg') || box.matches(OWN)) return;
        var br = box.getBoundingClientRect();
        if (br.width < 280 || br.height < 240) return;
        if (!isDark(getComputedStyle(box).backgroundColor)) return;
        if (box.parentElement && box.parentElement.closest('.hc-fx-dark')) return;
        // Cards narrower than the section hold body copy, so their pixels stay softer.
        dressDark(box, idx++, br.width < sr.width * .9);
      });
    });

    // Heroes that paint a dark gradient instead of a flat colour: dress the nearest such ancestor of the main heading.
    function darkGradient(el) {
      var bi = getComputedStyle(el).backgroundImage;
      if (bi.indexOf('gradient') < 0) return false;
      var cols = bi.match(/rgba?\([^)]*\)/g) || [];
      if (!cols.length) return false;
      var dark = cols.filter(function (c) { var v = rgb(c); return v && (v.a < .2 || v.r + v.g + v.b < 120); }).length;
      return dark / cols.length >= .5 && isDark(getComputedStyle(document.body).backgroundColor) || dark === cols.length;
    }
    var heroH1 = main.querySelector('h1');
    if (heroH1 && !heroH1.closest('.hc-fx-dark') && !heroH1.closest(OWN)) {
      for (var a = heroH1.parentElement; a && a !== main; a = a.parentElement) {
        if (a.getBoundingClientRect().width < window.innerWidth * .9) continue;
        if (darkGradient(a)) { dressDark(a, idx++); break; }
      }
    }

    /* 3. Hand-drawn underline under the last word of the page's main heading. */
    var h1 = main.querySelector('h1');
    if (h1 && !h1.closest(OWN) && parseFloat(getComputedStyle(h1).fontSize) >= 30 && !h1.querySelector('.hc-fx-ul')) {
      var walker = document.createTreeWalker(h1, NodeFilter.SHOW_TEXT, null), node, last = null;
      while ((node = walker.nextNode())) if (node.nodeValue.trim()) last = node;
      if (last) {
        var m = last.nodeValue.match(/^([\s\S]*?)(\S+)(\s*)$/);
        if (m && m[2].length > 2) {
          var span = document.createElement('span');
          span.className = 'hc-fx-ul';
          span.textContent = m[2];
          span.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 200 12" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path pathLength="1" d="M2 8.5C40 4 92 2.5 130 4.2S184 7.5 198 5.5"/></svg>');
          var frag = document.createDocumentFragment();
          if (m[1]) frag.appendChild(document.createTextNode(m[1]));
          frag.appendChild(span);
          if (m[3]) frag.appendChild(document.createTextNode(m[3]));
          last.parentNode.replaceChild(frag, last);
        }
      }
    }
  }

  /* 4. Footer wordmark. */
  var foot = document.querySelector('.hc-footer');
  if (foot && !foot.querySelector('.hc-fx-wordmark')) {
    var wm = document.createElement('div');
    wm.className = 'hc-fx-wordmark';
    wm.setAttribute('aria-hidden', 'true');
    wm.innerHTML = 'High<span>Convert</span>';
    foot.appendChild(wm);
  }

  /* 5. In-view triggers: process steps and illustrations. */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-hc-art]').forEach(function (a) { a.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (el.hasAttribute('data-hc-art')) {
        // Starts on first view; the looping one pauses while off screen.
        if (e.isIntersecting) el.classList.add('is-in');
        if (el.classList.contains('hc-art--ads')) el.classList.toggle('is-paused', !e.isIntersecting);
        else if (e.isIntersecting) io.unobserve(el);
        return;
      }
      if (e.isIntersecting) { el.classList.add('is-in'); io.unobserve(el); }
    });
  }, { threshold: .3 });
  document.querySelectorAll('[data-hc-art]').forEach(function (a) { io.observe(a); });
  main.querySelectorAll('.process-list').forEach(function (list) {
    list.classList.add('hc-fx-steps');
    Array.prototype.forEach.call(list.querySelectorAll('.process-item'), function (it, k) { it.style.setProperty('--k', k); });
    io.observe(list);
  });
})();
